<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>

    <b-card class="bCardGlobal">
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Quejas</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>C-**</div>
        </b-col>
      </b-row>

      <div class="divSubtitulo">
        <p class="textSubtitulo">Dictamenes</p>
      </div>
      <div class="container-fluid main-component">
        <div class="row justify-content-around">
          <div class="col-sm-12 col-md-8 col-lg-8 col-xl-5">
            <b-card
                style="
                padding: 1%;
                width: 100%;
                border-radius: 20px;
                box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
              "
            >
              <p
                  style="
                  text-align: left;
                  color: #093974;
                  font-size: 18px;
                  font-weight: 600;
                "
              >
                Información de la queja
              </p>
              <b-table-simple style="margin-top: 7%">
                <tr>
                  <td style="font-size: 15px"><label>ID Paciente</label></td>
                  <td style="font-size: 15px">{{ datos.idPaciente }}</td>
                </tr>
                <tr>
                  <td style="font-size: 15px">
                    <label>Nombre del Paciente</label>
                  </td>
                  <td style="font-size: 15px">{{ datos.paciente }}</td>
                </tr>
              </b-table-simple>
              <div style="margin-top: 10%">
                <p>
                  A través de <strong>{{ datos.origen }}</strong> el paciente
                  comenta:
                </p>
                <p v-if="datos.comentarios.length < 160">
                  <strong>{{ datos.comentarios }}</strong>
                </p>
                <b-button v-else @click="abrirModalInfoDictamen('El paciente comenta:',datos.comentarios) "
                >Ver comentarios
                </b-button
                >
              </div>
            </b-card>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-7">
            <b-card
                v-b-toggle.collapse-1
                style="
                padding: 1%;
                margin: 1%;
                width: 100%;
                border-radius: 20px;
                box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
              "
            >
              <p
                  style="
                  text-align: left;
                  color: #093974;
                  font-size: 18px;
                  font-weight: 600;
                "
              >
                Dictamen de operaciones    <font-awesome-icon class="editar" icon="arrow-down"/>
              </p>

              <b-collapse id="collapse-1" class="mx-auto">
                <div class="container-fluid main-component">
                  <b-table-simple responsive>
                    <tr>
                      <td>
                        <label
                        >Tipo de Px (Nat o Plan) / Para reforzar aviso a
                          Comercial</label
                        >
                      </td>
                      <td>{{ dictamen.idTipoPaciente }}</td>
                      <td><label>Historia</label></td>
                      <td v-if="dictamen.historia  !== null && dictamen.historia.length < 10">
                        {{ dictamen.historia  }}
                      </td>
                      <td v-else>
                        <b-button
                            variant="info"
                            @click="abrirModalInfoDictamen('Historia:',dictamen.historia ) ">
                          <em class="fa fa-eye"></em></b-button>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label>Antigüedad del Px atendiéndose en Dentalia</label>
                      </td>
                      <td>{{ dictamen.antiguedad }}</td>
                      <td><label>Monto Total del PTI</label></td>
                      <td>{{ dictamen.montoPti | monedaEntero }}</td>
                    </tr>
                    <tr>
                      <td>
                        <label>Familiares o referidos atendiéndose en Dentalia</label>
                      </td>
                      <td>{{ dictamen.antiguedad ? "Si" : "No" }}</td>
                      <td><label>¿Es imputable al doctor?</label></td>
                      <td>{{ dictamen.imputableDoctor ? "Si" : "No" }}</td>
                    </tr>
                    <tr>
                      <td><label>Constancia de su atención (repetitivo)</label></td>
                      <td>{{ dictamen.recurrente ? "Si" : "No" }}</td>
                      <td></td>
                      <td></td>
                    </tr>

                    <tr>
                      <td><label>Sugerencia CC, ¿entra en garantía?</label></td>
                      <td>{{ dictamen.esGarantiaCC ? "Si" : "No" }}</td>
                      <td><label>Descripcion de la sugerencia CC</label></td>
                      <td v-if="dictamen.descripcionGarantiaCC !== null && dictamen.descripcionGarantiaCC.length < 10">
                        {{ dictamen.descripcionGarantiaCC }}
                      </td>
                      <td v-else>
                        <b-button
                            variant="info"
                            @click="abrirModalInfoDictamen('Descripción de la sugerencia CC:',dictamen.descripcionGarantiaCC) ">
                          <em class="fa fa-eye"></em></b-button>
                      </td>
                    </tr>
                    <tr>
                      <td><label>Sugerencia CZ, ¿entra en garantía?</label></td>
                      <td>{{ dictamen.esGarantiaCZ ? "Si" : "No" }}</td>
                      <td><label>Descripcion de la sugerencia CZ</label></td>
                      <td v-if="dictamen.descripcionGarantiaCZ !== null && dictamen.descripcionGarantiaCZ.length < 10">
                        {{ dictamen.descripcionGarantiaCZ }}
                      </td>
                      <td v-else>
                        <b-button
                        variant="info"
                            @click="abrirModalInfoDictamen('Descripción de la sugerencia CZ:',dictamen.descripcionGarantiaCZ) ">
                          <em class="fa fa-eye"></em></b-button>
                      </td>
                    </tr>
                    <tr>
                      <td><label>¿Entra en garantía?</label></td>
                      <td>{{ dictamen.esGarantiaVO ? "Si" : "No" }}</td>
                      <td><label>Razon</label></td>
                      <td v-if="dictamen.razon !== null && dictamen.razon.length < 10">{{ dictamen.razon }}</td>
                      <td v-else>
                        <b-button variant="info" @click="abrirModalInfoDictamen('Razón de la garantía:',dictamen.razon) "><em
                            class="fa fa-eye"></em></b-button>
                      </td>
                    </tr>
                    <tr>
                      <td><label>Tratamiento Origen</label></td>
                      <td>
                        <ul>
                          <li
                              v-for="(t, i) in dictamen.tramientosOrigen"
                              :key="t + i"
                          >
                            {{ t }}
                          </li>
                        </ul>
                      </td>
                      <td><label>Tratamientos a garantía</label></td>
                      <td>
                        <ul>
                          <li
                              v-for="(t, i) in dictamen.tramientosGarantia"
                              :key="t + i"
                          >
                            {{ t }}
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </b-table-simple>
                </div>

              </b-collapse>
            </b-card>
            <b-card
                v-if="dental.resolucion !== null"
                v-b-toggle.collapse-2
                style="
                padding: 1%;
                margin: 1%;
                width: 100%;
                border-radius: 20px;
                box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
              "
            >
              <p
                  style="
                  text-align: left;
                  color: #093974;
                  font-size: 18px;
                  font-weight: 600;
                "
              >
                Dictamen dental
              </p>
              <b-collapse id="collapse-2" class="mx-auto">
                <div class="container-fluid main-component">
                  <b-table-simple responsive>
                    <tr>
                      <td><label>Resolución</label></td>

                      <td v-if="dental.resolucion.length < 10">{{ dental.resolucion }}</td>
                      <td v-else>
                        <b-button variant="info" @click="abrirModalInfoDictamen('Resolución del dictamen dental:',dental.resolucion) ">
                          <em class="fa fa-eye"></em></b-button>
                      </td>
                    </tr>
                    <tr>
                      <td><label>Doctor imputado</label></td>
                      <td>{{ dental.empleadoimputado }}</td>
                    </tr>
                    <tr>
                      <td><label>Sugerencia</label></td>

                      <td v-if="dental.sugerencia.length < 10">{{ dental.sugerencia }}</td>
                      <td v-else>
                        <b-button variant="info" @click="abrirModalInfoDictamen('Sugerencia del dictamen dental:',dental.sugerencia) ">
                          <em class="fa fa-eye"></em></b-button>
                      </td>
                    </tr>
                    <tr>
                      <td><label>Notas especiales</label></td>
                      <td v-if="dental.notasEspeciales.length < 10">{{ dental.notasEspeciales }}</td>
                      <td v-else>
                        <b-button
                        variant="info"
                            @click="abrirModalInfoDictamen('Notas especiales del dictamen dental:',dental.notasEspeciales) ">
                          <em class="fa fa-eye"></em></b-button>
                      </td>
                    </tr>
                    <tr v-for="(item, i) in dental.rutas" :key="'dental-' + i">
                      <td><label>Diente </label></td>
                      <td>{{ item.diente }}</td>

                      <td><label>Resolución</label></td>
                      <td>{{ item.dato }}</td>
                      <td v-if="item.dato.length < 10">{{ item.dato }}</td>
                      <td v-else>
                        <b-button  variant="info" @click="abrirModalInfoDictamen('Resolución:',item.dato) "><em class="fa fa-eye"></em>
                        </b-button>
                      </td>
                    </tr>

                    <tr>
                      <td colspan="4" class="text-center">Tratamientos</td>
                    </tr>
                    <tr v-for="(item, i) in dental.txs" :key="'tx-' + i">
                      <td>{{ item }}</td>
                    </tr>
                  </b-table-simple>
                </div>
              </b-collapse>
            </b-card>
          </div>
        </div>
      </div>
      <b-row class="pb-3 pt-5 text-center">
        <b-col>
          <h4>¿El dictamen se aprueba?</h4>
          <b-row>
            <b-col>
              <b-button-group v-if="!loaderGuardar">
                <b-button variant="primary" @click="guardar(true)">
                  Si
                </b-button
                >
                <b-button variant="secondary" @click="guardar(false)">
                  No
                </b-button
                >
              </b-button-group>
              <span v-else>
                  <b-spinner></b-spinner>
                </span>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

    </b-card>
    <b-modal
        v-model="modalInfoDictamen"
        title="Comentarios del paciente"
        scrollable
        size="lg"
    >
      <p style="font-size: 18px; font-weight: 600">{{ tituloInfoDictamen }}</p>
      <div class="container-fluid main-component p-3 text-justify">
        <p>{{ infoDictamen }}</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Header from "../../../components/Header";
import {GarantiaService} from "../../../apiServices/garantias/GarantiaService";

export default {
  name: "RevisionDictamenes",
  components: { Header},
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      garantiaServicio: new GarantiaService(),
      idTicket: null,
      idEtapa: null,
      loaderGuardar: false,

      datos: {
        origen: "",
        comentarios: "",
        idPaciente: "",
        paciente: "",
        driver: "",
        tema: "",
        subtema: "",
      },
      dictamen: {
        idDictamnOperaciones: null,
        idTipoPaciente: null,
        idSolicitud: null,
        idTipoPanciente: null,
        antiguedad: null,
        familiares: null,
        recurrente: null,
        historia: null,
        montoPti: null,
        imputableDoctor: null,
        esGarantiaCC: null,
        descripcionGarantiaCC: null,
        esGarantiaCZ: null,
        descripcionGarantiaCZ: null,
        esGarantiaVO: null,
        razon: null,
        txsOrigen: [],
        txsGarantia: [],
        tramientosOrigen: [],
        tramientosGarantia: [],
      },
      dental: {
        idSolicitud: null,
        resolucion: null,
        idEmpleadoimputado: null,
        empleadoimputado: null,
        idSugerenciaResolucion: null,
        sugerencia: null,
        notasEspeciales: null,
      },
      modalInfoDictamen: false,
      tituloInfoDictamen: "",
      infoDictamen: "",
    };
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.idTicket = this.$route.params.id;
    this.idEtapa = this.$route.params.idEtapa;
    this.obtenerDictamen();
    this.obtenerDictamenDental();
    this.obtenerInformacionTicket();
  },
  methods: {
    abrirModalInfoDictamen(tituloInfo, info) {
      this.tituloInfoDictamen = tituloInfo;
      this.infoDictamen = info;
      this.modalInfoDictamen = true;

    },
    obtenerInformacionTicket() {
      const parametros = {idSolicitud: this.idTicket}
      this.garantiaServicio.obtenerTicket(parametros).then((respuesta) => {
        this.datos = respuesta.data;
      });
    },
    obtenerDictamen() {
      const parametros = {idSolicitud: this.idTicket}
      this.garantiaServicio.obtenerDictamen(parametros).then((respuesta) => {
        this.dictamen = respuesta.data;
      });
    },
    obtenerDictamenDental() {
      const parametros = {idSolicitud: this.idTicket}
      this.garantiaServicio
          .obtenerDictamenDental(parametros)
          .then((respuesta) => {
            this.dental = respuesta.data;
          });
    },
    guardar(respuesta) {
      this.loaderGuardar = true;
      this.garantiaServicio
          .dictamenAprobado(respuesta, this.idTicket, this.idEtapa)
          .then(() => {
            this.$swal({
              icon: "success",
              title: "Se registro correctamente",
              showConfirmButton: false,
            });
            window.history.back()
          })
          .finally(() => {
            this.loaderGuardar = false;
          });
    },
  },
};
</script>

<style scoped>
.bCardGlobal {
  margin: 2% 4% 2% 4%;
  padding: 0.5% 1% 0.5% 1%;
  border-radius: 20px;
}

.divSubtitulo {
  width: 100%;
  margin-top: 2%;
  border-bottom: 5px solid #8ec6e9;
}

.divInput {
  width: 100%;
  margin-left: 1%;
  margin-right: 3%;
}

.textSubtitulo {
  color: #093974;
  font-weight: 600;
  font-size: 22px;
  text-align: left;
}
</style>
